import {translations} from 'presentation/translations-new';
import IconNamesType from 'presentation/icons/IconNamesType';

const {dataSharing} = translations['pt-br'].privateFlow.profile;

const ENABLED_FEATURES: Array<{
	key: string;
	iconName: IconNamesType;
	title: string;
	description: string;
}> = [
	{
		iconName: 'calendar-focused-filled',
		key: 'scheduling',
		title: dataSharing.enabledFeatures.scheduling.title,
		description: dataSharing.enabledFeatures.scheduling.description,
	},
	{
		iconName: 'video-camera-front-filled',
		key: 'digitalUrgentCare',
		title: dataSharing.enabledFeatures.digitalUrgentCare.title,
		description: dataSharing.enabledFeatures.digitalUrgentCare.description,
	},
	{
		iconName: 'id-card',
		key: 'healthCard',
		title: dataSharing.enabledFeatures.healthCard.title,
		description: dataSharing.enabledFeatures.healthCard.description,
	},
	{
		iconName: 'assignment-filled',
		key: 'referrals',
		title: dataSharing.enabledFeatures.referrals.title,
		description: dataSharing.enabledFeatures.referrals.description,
	},
	{
		iconName: 'landscape',
		key: 'examResults',
		title: dataSharing.enabledFeatures.examResults.title,
		description: dataSharing.enabledFeatures.examResults.description,
	},
	{
		iconName: 'shield-health-outlined',
		key: 'procedureAuthorization',
		title: dataSharing.enabledFeatures.procedureAuthorization.title,
		description: dataSharing.enabledFeatures.procedureAuthorization.description,
	},
	{
		iconName: 'chat-filled',
		key: 'serviceChannels',
		title: dataSharing.enabledFeatures.serviceChannels.title,
		description: dataSharing.enabledFeatures.serviceChannels.description,
	},
	{
		iconName: 'stethoscope',
		key: 'healthQueries',
		title: dataSharing.enabledFeatures.healthQueries.title,
		description: dataSharing.enabledFeatures.healthQueries.description,
	},
	{
		iconName: 'tooth-outline',
		key: 'dentalQueries',
		title: dataSharing.enabledFeatures.dentalQueries.title,
		description: dataSharing.enabledFeatures.dentalQueries.description,
	},
	{
		iconName: 'account-balance-default',
		key: 'financial',
		title: dataSharing.enabledFeatures.financial.title,
		description: dataSharing.enabledFeatures.financial.description,
	},
	{
		iconName: 'drawer',
		key: 'planManagement',
		title: dataSharing.enabledFeatures.planManagement.title,
		description: dataSharing.enabledFeatures.planManagement.description,
	},
	{
		iconName: 'percent-discount',
		key: 'benefits',
		title: dataSharing.enabledFeatures.benefits.title,
		description: dataSharing.enabledFeatures.benefits.description,
	},
	{
		iconName: 'ben-mail-outline-filled',
		key: 'portability',
		title: dataSharing.enabledFeatures.portability.title,
		description: dataSharing.enabledFeatures.portability.description,
	},
];

export {ENABLED_FEATURES};
